// 西班牙语
const es = {
    next: 'Próximo',
    error: 'Error',
    notFound: '404 No encontrado.',
    m: {
        loginTitle: "Desbloquea tu Power Bank",
        phonePlaceholder: "Número de móvil",
        or: 'o',
        emailLogin: 'Continuar con correo electrónico',
        phoneLogin: 'Continuar con teléfono',
        quickLogin: 'Continuar como invitado',
        loginRequiredTip: 'Inicia sesión primero',
        continueGoogle: "Continuar con Google",
        continueApple: "Continuar con Apple",
        langBoxTitle: "Elige un idioma",
        policyAndTerms: "Acepto los <a href='[termsOfServiceUrl]'>Términos de servicio</a> y la <a href='[privacyPolicyUrl]'>Política de privacidad</a> de [brandName].",
        verifyTitle: 'Ingrese el código de 6 dígitos enviado a [phonenumber]',
        verifyEmailTitle: 'Ingrese el código de 6 dígitos enviado a [email]',
        paymentTitle: 'Desbloquea tu Power Bank',
        resend: "Reenviar código",
        emailAddress: "Correo electrónico",
        registerTitle: 'Ingrese su información.',
        fNameInput: 'Nombre',
        lNameInput: 'Apellido',
        emailInput: 'Correo electrónico',
        birthInput: 'Fecha de nacimiento',
        postCodeInput: 'Código postal',
        billingRate: 'Tarifa',
        unpaidPopupSubtitle: "Tienes un pedido pendiente de pago",
        unpaidPopupContent: "Tienes un pedido pendiente de pago. Por favor, realiza el pago antes de volver a alquilar.",
        payNow: "Pagar ahora",
        add: "Agregar",
        minBalanceTag: 'Mín.: {amount}',
        paymentSuccessfulSubtitle: "¡Pago exitoso!",
        paymentSuccessfulContent: "¡Ahora puede continuar con su alquiler!",
        goToRental: "Ir al alquiler",
        repaymentTitle: "Pago del pedido",
        rentalInformation: "Información del alquiler",
        selectPayMethod: 'Seleccionar método de pago',
        selectAuthorizationMethod: 'Seleccionar método de autorización',
        applePay: 'Apple Pay',
        googlePay: 'Google Pay',
        balance: 'Saldo',
        creditOrDebit: 'Crédito/Débito',
        free: 'Gratis',
        pay: 'Pagar',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        unlockNow: 'Desbloquear Power Bank',
        savePay: 'Guardar y pagar',
        saveRent: 'Alquilar',
        recharge: 'Recargar',
        balancePopupTitle: 'Recargar',
        balancePopupCurrentBalance: 'Saldo actual: {amount}',
        balancePopupMinRentBalance: 'Saldo mínimo para alquilar: {amount}',
        topUpRent: 'Recargar',
        topUpSaveCard: 'Recargar',
        bindPopupTitle: 'Agregar tarjeta de pago',
        cardPaymentTitle: 'Pago con tarjeta',
        preparingTitle: 'Preparando tu cargador',
        preparingSubtitle: 'Tu Power Bank está siendo expulsada. Por favor, espera pacientemente.',
        preparingStationBusySubtitle: 'Esperando a que termine la expulsión anterior. Por favor, espera.',
        rentalSuccessTitle: '¡Éxito!',
        rentalFailTitle: 'Fallo!',
        rentalSuccessSubtitle: 'Gracias por usar [brandName]. Por favor, devuelve la Power Bank después de usarla.',
        rentalNumber: 'Número de alquiler',
        rentalTime: 'Tiempo de alquiler',
        rentalLocation: 'Ubicación de alquiler',
        returnTime: "Hora de devolución",
        returnLocation: "Lugar de devolución",
        rentalDuration: "Duración del alquiler",
        totalAmount: "Monto Total",
        paidAmount: "Monto Pagado",
        unpaidAmount: "Monto pendiente",
        currentFee: "Tarifa actual",
        rentalInfo: 'Información del alquiler',
        rentingTitle: 'Actualmente estás usando una batería [brandName]',
        keepIt: '¿Quieres quedártela? ¡Cómprala ahora!',
        findNearby: 'Encuentra estaciones de devolución cercanas fácilmente: ¡descarga nuestra app ahora!',
        nearbyStationTitle: 'Estaciones cercanas',
        nearbyStationSearchPlaceholder: 'Buscar estaciones de carga cercanas',
        nearbyStationRent: 'Alquilar',
        nearbyStationReturn: 'Devolver',
        nearbyStationAvailable: 'Disponible',
        nearbyStationEmpty: 'Vacío',
        nearbyStationLoading: 'Cargando estaciones cercanas...',
        nearbyStationNoStations: 'No hay estaciones cercanas',
        nearbyStationNoRentStations: 'No hay estaciones cercanas para alquilar',
        nearbyStationNoReturnStations: 'No hay estaciones cercanas para devolver',
        nearbyStationSearchAria: 'Buscar estaciones cercanas',
        nearbyStationType: 'Tipo de estación',
        nearbyStationDistance: 'Distancia',
        scanForPowerbank: 'Escanear Power Bank',
        scanOtherMachine: 'Scan other machine',
        findNearbyReturnableMachines: 'Máquinas para devolver',
        scannedMachine: 'Scanned machine',
        scannedMachineWithCode: 'Scanned machine {code}',
        loginViewNearbyRentableMachines: 'Ver otras máquinas cercanas',
        viewNearbyReturnLocations: 'Máquinas para devolver',
        currentMachineUnavailableHint: 'This machine is not available',
        currentMachineAvailableHint: 'La máquina actual está lista',
        currentMachineMapDetail: 'You scanned machine {code}. Tap here to return and continue renting from this machine.',
        currentMachineMapAction: 'Tap to continue renting from this machine.',
        machineUnavailableMapDetail: 'You scanned machine {code}, but it cannot be used now. Reason: {reason}. Please scan another machine or use nearby stations on the map.',
        machineUnavailableMapAction: 'Busca una máquina disponible cercana y escanea su código.',
        mapIslandMachineUnavailableShort: 'Esta máquina no está disponible',
        mapIslandMachineAvailableActionShort: 'Continuar con esta máquina',
        mapIslandMachineUnavailableActionShort: 'Escanea otra máquina cercana',
        mapIslandReturnActionShort: 'Volver al alquiler',
        rentingMapIslandTitle: 'Alquiler en curso',
        tapToReturnRentalPage: 'Toque para volver al alquiler.',
        scan: 'Escanear',
        scannerHint: 'Busca el código QR en la estación de carga',
        flashlight: 'Linterna',
        mapBack: 'Atrás',
        currentLocation: 'Ubicación actual',
        backToMap: 'Volver al mapa',
        mapMenu: 'Menú',
        mapMenuYourInfo: 'Tus datos',
        mapMenuLanguage: 'Idioma',
        mapMenuHelp: 'Ayuda',
        helpTitle: 'Ayuda',
        helpReportProblem: 'Reportar un problema',
        helpChatWithUs: 'Chatea con nosotros',
        chatWithUsTitle: 'Chatea con nosotros',
        chatContactMethods: 'Métodos de contacto',
        reportProblemTitle: 'Reportar un problema',
        reportDeviceCode: 'Código del dispositivo',
        reportScanQrCode: 'Escanear QR de la máquina',
        reportDeviceCodePlaceholder: 'Escanee el QR de la máquina o introduzca el ID del dispositivo',
        reportProblemType: 'Problema',
        reportProblemTypeAria: 'Tipo de problema',
        reportProblemPowerBankNotEjected: 'Power bank no expulsado',
        reportProblemCannotChargeDevice: 'No carga el dispositivo',
        reportProblemOrderNotEnded: 'Pedido no finalizado',
        reportProblemCableDamagedLost: 'Cable dañado/perdido',
        reportProblemOther: 'Otro',
        reportTakePicture: 'Subir imagen',
        reportChooseOrTakePicture: 'Subir imagen',
        reportRemovePicture: 'Eliminar foto',
        reportDescribeProblem: 'Describe el problema',
        reportDescriptionPlaceholder: 'Introduce una descripción',
        reportFieldRequired: 'Obligatorio',
        reportFieldOptional: 'Opcional',
        reportSubmit: 'Enviar',
        reportSubmittedSuccessfully: 'Enviado correctamente',
        mapMenuLogin: 'Iniciar sesión',
        mapMenuLogout: 'Cerrar sesión',
        mapMenuLogoutSuccess: 'Sesión cerrada',
        mapMenuLoadingProfile: 'Cargando perfil...',
        mapMenuLogoutConfirmTitle: '¿Cerrar sesión?',
        mapMenuLogoutConfirmContent: 'Tendrás que iniciar sesión de nuevo antes de alquilar.',
        profileTitle: 'Perfil',
        profileSave: 'Guardar',
        profileNoChanges: 'Actualiza al menos un campo con un valor.',
        profileDeleteAccount: 'Eliminar',
        profileDeleteConfirmTitle: '¿Eliminar cuenta?',
        profileDeleteConfirmContent: 'Todos los datos de tu cuenta se eliminarán de forma permanente y se cerrará tu sesión después de la eliminación.',
        closeScanner: 'Cerrar escáner',
        directions: 'Indicaciones',
        call: 'Llamar',
        cabinet: 'Estación',
        addressUnavailable: 'Dirección no disponible',
        open: 'Abierto',
        closed: 'Cerrado',
        opens: 'Abre',
        closes: 'Cierra',
        hoursUnavailable: 'Horario no disponible',
        mapUnavailable: 'Mapa no disponible',
        googleMapsKeyNotConfigured: 'La clave de Google Maps no está configurada',
        googleMapsLoadFailed: 'Error al cargar Google Maps',
        retry: 'Reintentar',
        mapLoading: 'Cargando mapa...',
        mapReloading: 'Recargando mapa...',
        cameraUnavailable: 'La cámara no está disponible en este navegador',
        cameraPermissionDenied: 'Se denegó el permiso de la cámara',
        cameraStartFailed: 'No se pudo iniciar la cámara',
        flashlightUnsupported: 'La linterna no es compatible con este dispositivo',
        flashlightSwitchFailed: 'No se pudo cambiar la linterna',
        invalidQrCode: 'Formato de código QR no válido',
        noon: 'Mediodía',
        weekdayMonday: 'Lunes',
        weekdayTuesday: 'Martes',
        weekdayWednesday: 'Miércoles',
        weekdayThursday: 'Jueves',
        weekdayFriday: 'Viernes',
        weekdaySaturday: 'Sábado',
        weekdaySunday: 'Domingo',
        weekdayMon: 'Lun',
        weekdayTue: 'Mar',
        weekdayWed: 'Mié',
        weekdayThu: 'Jue',
        weekdayFri: 'Vie',
        weekdaySat: 'Sáb',
        weekdaySun: 'Dom',
        orderDeatil: 'Detalles del pedido',

        subsTitle: 'Seleccionar plan',
        default: 'Predeterminado',
        subscribeAndSave: 'Suscripción y guardado',
        autoRenew: 'Renovación automática',
        reachLimit: 'Límite de uso alcanzado',
        paymentAuthorizationTitle: 'Autorización de pago',
        paymentAuthorizationRequired: 'Se requiere autorización de pago',
        paymentAuthorizationDesc1: '',
        paymentAuthorizationDesc2: 'Se requiere una autorización si el alquiler puede exceder su plan o si no hay un método de pago vinculado para posibles cargos adicionales.',
        paymentAuthorizationDesc3: 'Se realizará una retención temporal de [amount]. Se liberará por completo después de la devolución si no se aplican cargos adicionales; de lo contrario, se reembolsará el saldo restante tras descontar cualquier cargo adicional.',
        paymentAuthorizationDesc4: 'Seleccione uno de los siguientes métodos de autorización para este alquiler.',

        totalCost: 'Costo total',
        returnSuccessTitle: '¡Devolución exitosa!',
        returnSuccessSubtitle: 'Gracias por usar [brandName].',
        rentAgain: 'Alquilar de nuevo',
        guestLoginTips: 'Esta función requiere una cuenta formal. El modo invitado no está disponible. ¿Le gustaría iniciar sesión?',
        stationNotFoundTitle: "Station Not Found",
        stationNotFound: "Please try scanning the code again.",
        stationNotSetUpTitle: "Station Not Set Up",
        stationNotSetUp: "Please contact the administrator for assistance, or check other nearby stations.",
        stationOfflineTitle: "Station Offline",
        stationOffline: "Please check if the power cable is properly connected, or try unplugging and re-plugging it.",
        stationBusyTitle: "Station Busy",
        stationBusy: "The station is currently processing the rental task. Please wait a moment and try again.",
        powerBanksUnavailableTitle: "Power Banks Unavailable",
        powerBanksUnavailable: "Power banks are temporarily unavailable due to a technical issue. Please try again later or check another nearby station.",
        noPowerBanksAvailableTitle: "No Power Banks Available",
        noPowerBanksAvailable: "Please check another nearby station.",
        serverErrorTitle: "Server Error",
        serverError: "Please try again later, or contact the administrator for assistance.",
    },
    tMsg: {
        agreePolicy: 'Aceptar [brandName]’s política de privacidad y los términos y condiciones',
        errorTel: 'Por favor ingresa un número de teléfono correcto',
        sendSuccess: 'Enviado correctamente',
        inputAll: 'Por favor complete toda la información requerida',
        wrongEmail: 'Formato de correo electrónico incorrecto',
        wrongBirthday: 'Por favor ingresa tu fecha de nacimiento en el formato correcto',
        initPayFail: 'El pago inicial falló',
        bindTimeout: 'Tiempo de espera de vinculación de tarjeta agotado, inténtalo de nuevo',
        bindSuccess: 'Tarjeta vinculada correctamente',
        subscriptionSuccess: 'Suscripción comprada con éxito',
        bindFailed: 'Error al vincular la tarjeta',
        paymentFailed: 'Pago fallido',
        loginError: 'Error de inicio de sesión',
        paymentMethodNotSupported: 'Método de pago no compatible',
    },
    bRule: {
        priceDesc: '[price]',
        priceTimeDesc: '/[price_time] minutos',
        freeTimeDesc: '[free_time] minutos gratis',
        flatFeeDesc: '[flat_fee] tarifa plana para los primeros [flat_fee_time] minutos',
        lowLimitDesc: 'Tarifa mínima: [low_limit]',
        topLimitDesc: 'Tarifa máxima diaria: [top_limit]',
        preAuthDesc: '[pre_auth_amount] será preautorizado en su método de pago',
        depositDesc: 'Si no se devuelve dentro de [maximum_rental_time] horas, se cobrará [deposit] y la power bank será suya',
        ruleError: 'Error de regla',
        noneRuleDesc: 'Sin reglas',
        taxIncluded: 'Impuestos incluidos',
        taxIncludedWithRate: 'Incluye [tax]% de impuestos'
    },
    subscriptionType: {
        1: 'Gratis [value] minutos por período de suscripción',
        2: 'Gratis [value] minutos por mes',
        3: 'Gratis [value] minutos por semana',
        4: 'Gratis [value] minutos por día',
        6: 'Gratis [value] veces por período de suscripción',
        7: 'Gratis [value] veces por mes',
        8: 'Gratis [value] veces por semana',
        9: 'Gratis [value] veces por día',
        unlimited: 'ilimitado',
        unlimitedRentals: 'Alquileres ilimitados gratis por período de suscripción',
        durationLimit: 'Hasta [limit] minutos de alquiler gratuito por alquiler. Luego [price] por [price_time] minutos',
        maxLimit: ', máximo [top_limit] por día',
    },
    subscriptionTitleType: {
        1: '[value] minutos por período de suscripción',
        2: '[value] minutos por mes',
        3: '[value] minutos por semana',
        4: '[value] minutos por día',
        6: '[value] veces por período de suscripción',
        7: '[value] veces por mes',
        8: '[value] veces por semana',
        9: '[value] veces por día',
        unlimited: 'Ilimitado',
        unlimitedRentals: 'Alquileres ilimitados por período de suscripción',
    },
    subscriptionInfo: {
        period: 'Período: [start] - [end]',
        usedShort: '([used]/[total] usado)',
        usage: 'Uso: [total] en total, [used] usado, [remaining] restante',
        usageUnlimited: 'Uso: ilimitado',
        autoRenew: 'Renovación automática: [value]',
        autoRenewTrue: 'Sí',
        autoRenewFalse: 'No',
    },
    time: {
        day: 'día | días',
        hour: 'hora | horas',
        minute: 'minuto | minutos',
        second: 'segundo | segundos',
        month: 'mes | meses',
        year: 'año | años'
    },
    eMsg: {
        30001: 'Human verification failed',
        500: "error de red",
        1000: "proceso fallido",
        30022: "Por favor ingresa tu número de teléfono en el formato correcto",
        30128: "Código de verificación enviado demasiadas veces. Por favor, inténtelo de nuevo más tarde.",
        30129: "No se pudo enviar el código de verificación",
        //
        30101: 'El código de verificación es incorrecto o ya no es válido',
        // 租借
        50101: "Estación no encontrada",
        50105: "Tienes un pedido pendiente",
        50106: "La estación está actualmente fuera de línea",
        50108: "Actualmente no hay powerbanks disponibles",
        50109: "El problema del banco de energía falló. Por favor, inténtelo de nuevo más tarde.",
        50113: 'Esta estación requiere una cuenta',
        50114: 'Los invitados no pueden usar esta función. Inicia sesión',
        50111: 'Método de pago no válido',
        50305: 'Método de pago no válido',
        80411: 'No se pudo agregar el método de pago',
        50103: 'Ningún método de pago válido',
        50206: 'El pago de su último pedido falló. Por favor actualiza tu método de pago.',
    }
}
export default es
